// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__uRv_v","col":"styles_col__2GKWv","fulfillmentStatus":"styles_fulfillmentStatus__1dblS","emailCol":"styles_emailCol__1lX5x"};